import Firebase from 'firebase'

if (process.env.NODE_ENV === 'production')
  Raven.config('https://a94bc98568ae446fa3acb0a762724b9a@app.getsentry.com/73016').install()

export const firebaseRef = new Firebase('https://edgebet.firebaseio.com/')

export const restUrl = 'https://api.edgebet.net/'

export const NOTIFICATION_SOUND_URL = '/static/notification_sound.mp3'

export const TRIAL_DAYS = 14

export hobbyBookmakers from './hobbyBookmakers'
export bookmakers from './bookmakers'
export { recommendedLeagues } from './recommendedLeagues'
export disposableEmails from './disposableEmails'
export allBookmakers from './allBookmakers'



/** WEBPACK FOOTER **
 ** ./src/config/index.js
 **/